module.exports = __webpack_public_path__ + "img/right-curving-up.38ea617c.png";